import React from 'react'
import AutoplayContent from './Ui/Blocks/AutoplayContent'

const AutoplayNew = () => {
  return <AutoplayContent />
}

export default AutoplayNew
